var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurpleSignal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.33334H16.25V16.6667H13.75V3.33334ZM3.75 11.6667H6.25V16.6667H3.75V11.6667ZM11.25 7.50001H8.75V16.6667H11.25V7.50001Z",
    fill: "#B6B0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleSignal);
export default __webpack_public_path__ + "static/media/purple-signal.f6108b662377f9759193d8cf47d24aba.svg";
export { ForwardRef as ReactComponent };